import { createSelector } from "reselect"
import { get, chain } from "lodash"
import { getSelectedModelId as getPortfolioSelectedModelId } from "modules/portfolio-root/selectors/portfolios"

export const getModelsAvailability = state => get(state, "global.data.modelsAvailability.data.models")
const getDate = state => state.modules.securitiesFinder.selectedDate
const getRawSelectedModelId = (_, props) => get(props, "modelId")
const getRawSelectedDate = (_, props) => get(props, "selectedDate")

export const getSelectedModelId = createSelector(
  [getPortfolioSelectedModelId, getRawSelectedModelId],
  (portfolioSelectedModelId, modelId) => {
    return modelId || portfolioSelectedModelId
  },
)

export const getModelCurrentDate = createSelector(
  [getModelsAvailability, getSelectedModelId],
  (modelsAvailability, selectedModelId) => chain(modelsAvailability).find({ id: selectedModelId }).get("availability.currentDate").value(),
)

export const getModelStartDate = createSelector(
  [getModelsAvailability, getSelectedModelId],
  (modelsAvailability, selectedModelId) => chain(modelsAvailability).find({ id: selectedModelId }).get("availability.securitiesStartDate").value(),
)

export const getSelectedDate = createSelector(
  [getModelCurrentDate, getDate, getRawSelectedDate],
  (currentDate, date, rawDate) => rawDate || date || currentDate,
)
